import "core-js/stable";
import "regenerator-runtime/runtime";
import "./styles/index.less";
import "@aevi-pd/aevi-styles/dist/styles.css";

import { AuthProvider } from "auth/AuthProvider";
import { getBasePath } from "config/config";
import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { persistor, store } from "redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { GlobalRouter } from "router/GlobalRouter";

const container = document.getElementById("epms-container");
if (!container) {
    throw new Error("Root container not found");
}
const root = createRoot(container!);

root.render(
    <StrictMode>
        <AuthProvider>
            <ReduxProvider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <React.Suspense>
                        <BrowserRouter basename={getBasePath()}>
                            <GlobalRouter />
                        </BrowserRouter>
                    </React.Suspense>
                </PersistGate>
            </ReduxProvider>
        </AuthProvider>
    </StrictMode>,
);
